export { TabContent as Content } from './tab-content.js';
export { TabIndicator as Indicator } from './tab-indicator.js';
export { TabList as List } from './tab-list.js';
export { TabTrigger as Trigger } from './tab-trigger.js';
export { TabsContext as Context } from './tabs-context.js';
export { TabsRoot as Root } from './tabs-root.js';
export { TabsRootProvider as RootProvider } from './tabs-root-provider.js';
